import React, { useState, useEffect, useMemo } from 'react';
import { useApplicationStore } from 'src/store/application';
import { useInsuranceStore } from 'src/store/insurance';
import { useNavigate } from 'react-router-dom';
import { IdCardType } from 'src/services/interfaces/insurance';
import { cn } from '@utils/index';

export const IDCards = () => {
  const [selectedMember, setSelectedMember] = useState<string>('1');
  const navigate = useNavigate();

  const {
    activeSubscriptionPlans,
    fetchActiveSubscriptionPlans,
    applications,
    getCurrentApplication,
    submittedAt
  } = useApplicationStore();
  const { plans: allPlans } = useInsuranceStore();

  useEffect(() => {
    fetchActiveSubscriptionPlans();
    getCurrentApplication();
  }, [fetchActiveSubscriptionPlans, getCurrentApplication]);

  const displayedPlans = useMemo(() => {
    const planMap = new Map();
    console.log('selectedMember', selectedMember);

    const currentApplication = applications[0];
    const appPlansFromApplication = currentApplication?.plans || [];
    console.log('currentApplication', currentApplication);
    console.log('appPlansFromApplication', appPlansFromApplication);
    const hasActive = Array.isArray(activeSubscriptionPlans) && activeSubscriptionPlans.length > 0;
    const hasApplicationPlans = Array.isArray(appPlansFromApplication) && appPlansFromApplication.length > 0;

    let sourcePlans: any[] = hasActive
      ? activeSubscriptionPlans.map((sp: any) => ({ subscriptionId: sp.id, id: sp.planId, applicants: sp.applicants, status: sp.status }))
      : (hasApplicationPlans ? appPlansFromApplication : []);
    sourcePlans = sourcePlans
      .filter((plan: any) =>
        plan.applicants.map((item: any) => item.applicant).includes(Number(selectedMember || 0)
        ));
    sourcePlans.forEach((planLike: any) => {
      const details = allPlans.find((p) => p.id === planLike.id);
      const currentApplicant = planLike.applicants.find((applicant: any) => applicant.applicant === Number(selectedMember || 0));
      const disabled = (!currentApplicant?.groupId || !currentApplicant?.groupId);
      if (details && !planMap.has(details.id) && details?.idCard && details?.idCard > IdCardType.ClaimForm) {
        planMap.set(details.id, {
          subscriptionId: planLike.subscriptionId,
          id: details.id,
          uid: details.uid,
          name: details.name || details.marketingName,
          status: planLike.status ?? details.status,
          // logo: getPlanLogo(details),
          category: details.category,
          disabled,
        });
      }
    });

    console.log('planMap', planMap);
    console.log('sourcePlans', sourcePlans);

    return Array.from(planMap.values());
  }, [activeSubscriptionPlans, applications, allPlans, selectedMember]);

  const handleViewCard = (subscriptionId: number | string, applicantId: number | string) => {
    navigate(`/healthhub/id-cards/${subscriptionId}/${applicantId}`);
  };

  const currentApplication = applications[0];

  return (
    <div className="flex flex-col gap-8 mt-5">
      {/* Header Section */}
      <section className="flex flex-col rounded-3xl bg-profile-section-bg pb-5">
        <div className="bg-profile-header-bg overflow-hidden relative text-white pl-8 rounded-t-3xl py-7 text-[1.5vw] tracking-wide max-md:text-2xl max-md:py-5">
          <p className="text-3xl 2xl:text-4xl">Your ID Cards</p>
        </div>
        <div className="flex flex-col px-9 max-md:px-5 mt-5 pb-5">
          {/* Introductory Text */}
          <div className="mb-6">
            <h2 className="text-3xl font-bold text-black mb-4">
              Your digital ID cards go everywhere you go.
            </h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>You have access to your ID cards any time you need them right from here in your Health Portal.</li>
              <li>You can also download or print the ID card image to easily show or email it to your providers.</li>
            </ul>
          </div>

          {/* View ID Card(s) for Dropdown */}
          <div className="mb-8 flex items-center gap-4">
            <span className="text-xl text-gray-700 font-medium">View ID Card(s) for:</span>
            <select
              value={selectedMember}
              onChange={(e) => setSelectedMember(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg bg-white text-black cursor-pointer"
            >
              {currentApplication?.applicants?.map((applicant: any) => (
                <option value={applicant.applicant?.toString()}>{applicant.firstName}</option>
              ))}
            </select>
          </div>

          {/* ID Card Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {displayedPlans.length > 0 ? (
              displayedPlans.map((plan, index) => (
                <div
                  key={plan.id || index}
                  className="bg-white rounded-3xl max-md:rounded-2xl shadow-md overflow-hidden flex flex-col"
                >
                  {/* Plan Logo and Title */}
                  <div className="p-6 border-b border-gray-200">
                    <h3 className="text-xl font-bold text-primary mb-2">{plan.name} Plan</h3>
                    <p className="text-sm text-gray-600 mb-2">
                      Coverage effective (start) date: {submittedAt ? new Date(submittedAt).toLocaleDateString('en-US') : 'N/A'}
                    </p>
                    {plan.category !== 'Major Medical' && (
                      <p className="text-sm text-gray-700">
                        Your Plan: {plan.category}
                      </p>
                    )}
                  </div>

                  {/* VIEW CARD Button */}
                  <div className="p-6 pt-4 mt-auto">
                    <button disabled={plan.disabled} onClick={() => handleViewCard(plan.subscriptionId, selectedMember)}
                      className={cn("w-full bg-primary text-white font-bold py-3 rounded-full text-lg hover:bg-primary/90 transition-colors", plan.disabled && "bg-gray-300 cursor-not-allowed hover:bg-gray-300 text-gray-500")}>
                      {plan.disabled ? 'IN PROGRESS' : 'VIEW CARD'}
                    </button>
                    <p className="text-xs text-gray-500 text-center mt-3">
                      Use your digital ID card when you access care.
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full text-center py-10">
                <p className="text-xl text-gray-600">
                  No active plans found
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};